import {
  transformCompanyDetails,
  transformContactDetails,
  transformMessages,
  transformPersonalDetails,
} from './common.mapper';

import {
  AddressBookEntry,
  AddressBookInformation,
  ApiAddressBookEntry,
  ApiAddressBookInformation,
} from '../interfaces/address-book.interface';

export function transformAddressBookInformation(
  apiAddressBookInformation: ApiAddressBookInformation
): AddressBookInformation {
  const mappedAddressBookInformation: AddressBookInformation = {
    id: apiAddressBookInformation.id,
    created_at: apiAddressBookInformation.created_at,
  };

  if (apiAddressBookInformation.review) {
    mappedAddressBookInformation.review = {
      modified_at: apiAddressBookInformation.review.modified_at,
      comment: apiAddressBookInformation.review.comment,
      rating: apiAddressBookInformation.review.rating,
    };
  }

  return mappedAddressBookInformation;
}

export function transformAddressBookEntry(apiAddressBookEntry: ApiAddressBookEntry): AddressBookEntry {
  return {
    ...transformAddressBookInformation(apiAddressBookEntry),
    ...transformPersonalDetails(apiAddressBookEntry.contact.personal_details),
    ...transformCompanyDetails(apiAddressBookEntry.contact.company_details),
    ...transformContactDetails(apiAddressBookEntry.contact.contact_details),
    ...transformMessages(apiAddressBookEntry.contact.messages),
  };
}
